import { useQuery } from '@tanstack/react-query'

import type { ClinicId } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Fetches appointments for a date range. */
export function useListAppointments(opts: {
  refetchInterval?: number
  /** Start date (YYYY-MM-DD, inclusive). Query is disabled until both from and to are provided. */
  from?: string
  /** End date (YYYY-MM-DD, exclusive). Query is disabled until both from and to are provided. */
  to?: string
  clinicId?: ClinicId
  staffIds?: string[]
}) {
  const api = useOsApi()
  const { from, to } = opts

  return useQuery({
    queryKey: ['appointments', from, to, opts.clinicId, opts.staffIds],
    enabled: !!from && !!to,
    refetchInterval: opts.refetchInterval,
    queryFn: async () => {
      const response = await api.get('/appointments', {
        query: { from: from!, to: to!, clinicId: opts.clinicId, staffIds: opts.staffIds },
      })
      if (!response.success) throw new Error(response.error.message)
      return response.data.appointments
    },
  })
}
